module.exports = __webpack_public_path__ + "static/media/maldives.90147162.jpg";